import JobApplicationMain from './JobApplicationMain.component';

export default JobApplicationMain;
